import { h, defineComponent } from 'vue';
import { Icon } from '@/ui/components/icon/Icon';

interface MaintenanceBannerProps {
  display?: boolean;
  classes?: string;
}

export const MaintenanceBanner = defineComponent<MaintenanceBannerProps>({
  name: 'MaintenanceBanner',
  props: ['display', 'classes'],
  setup(props) {
    const isDisplayed = props.display || false;

    // no need to translate
    const maintenanceMessage = 'Due to maintenance work, inspections might be sent out '
      + 'with a delay (Fri - Sun, between 9pm and 9am UTC+2)';

    return function render() {
      return isDisplayed
        ? h('div', { class: `maintenance-banner ${props.classes || ''}` }, [
          h('div', { class: 'maintenance-banner__message' }, [
            h(Icon, {
              class: 'maintenance-banner__icon',
              props: {
                size: '2x',
                icon: 'exclamation-triangle',
              },
            }),
            h('div', [maintenanceMessage]),
          ]),
        ])
        : null;
    };
  },
});

export function maintenanceBanner(props?: MaintenanceBannerProps) {
  return h(MaintenanceBanner, { props });
}
